<template>
  <div>
    <template v-if="loading">
      <div class="d-flex align-center justify-center black" style="height: 100vh;">
        <v-progress-circular color="white" indeterminate></v-progress-circular>
      </div>
    </template>
    <template v-else-if="!currentInfo">
      <template v-if="activeReservation">
        <home-page :restaurant-info="restaurantInfo"/>
      </template>
      <template v-else>
        <error-page :shop-info="restaurantInfo"/>
      </template>
    </template>
    <template v-else>
      <detail-page
          :reservation-info="currentInfo"
          :restaurant-info="restaurantInfo"
          :token="token"
      />
    </template>
  </div>

</template>

<script>

import HomePage from './HomePage.vue'
import IKUtils from "innerken-js-utils";
import {getActiveCodes, getReservationByToken, getUserList, reportToCloud} from "../repository/api";
import DetailPage from "./DetailPage.vue";
import ErrorPage from "./ErrorPage.vue";

export default {
  name: 'App',
  components: {DetailPage, HomePage, ErrorPage},
  data: function () {
    return {
      token: '',
      restaurantInfo: null,
      loading: true,
      currentInfo: null,
      activeReservation: true,
    };
  },
  async mounted() {
    this.loading = true
    this.token = IKUtils.getQueryString('token')
    const subDomain = location.hostname.split('.')[0]
    const testDomains = ['localhost', 'aaden-reservation-front']
    const host = testDomains.includes(subDomain) ? 'innerken'
        : subDomain
    this.restaurantInfo = (await getUserList()).find(it => it.subDominName.toLowerCase() === host.toLowerCase())
    const res = await getActiveCodes(this.restaurantInfo.id)
    if (!res.includes('reservation')) {
      this.activeReservation = false
      this.loading = false
      return
    }
    console.log(this.restaurantInfo)
    try {
      await reportToCloud({
        deviceId:this.restaurantInfo.id,
        ip: "",
        uuid: location.host,
        version: require("../../package.json").version,
        frontendType: "reservation-customer",
        name: this.restaurantInfo.shopName,
      })
    } catch (e) {
      console.log(e)
    }
    try {
      this.currentInfo = await getReservationByToken(this.token)
    } catch (e) {
      console.log(e, 'catch')
    }


    this.loading = false
  }
}
</script>

<style>
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding-right: 8px !important;
}

</style>
